import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  libraries: ["places", "geometry", "drawing"],
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
});

loader
  .load()
  .then((google) => {
    window.google = google;
  })
  .catch((e) => {
    console.error(e);
  });
